/**
=========================================================
* Argon Dashboard 2 MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-material-ui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useEffect, ReactNode } from "react";

// react-router-dom components
import { useLocation } from "react-router-dom";

// Argon Dashboard 2 MUI components
import Box from "themeComponents/Box";

// Argon Dashboard 2 MUI context
import { useArgonController, setLayout } from "context";

interface DashboardLayoutProps {
  bgColor?: string;
  children: ReactNode;
  [key: string]: any;
}

function DashboardLayout({ bgColor, children, ...rest }: DashboardLayoutProps): React.JSX.Element {
  const [controller, dispatch] = useArgonController();
  const { miniSidenav, darkMode } = controller;
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [pathname, dispatch]);

  const background = darkMode && !bgColor ? "transparent" : bgColor;

  return (
    <Box
      sx={({ breakpoints, transitions, functions: { pxToRem } }: any) => ({
        p: 3,

        [breakpoints.up("xl")]: {
          marginLeft: miniSidenav ? pxToRem(120) : pxToRem(274),
          transition: transitions.create(["margin-left", "margin-right"], {
            easing: transitions.easing.easeInOut,
            duration: transitions.duration.standard,
          }),
        },
      }) as any}
    >
      <Box
        bgColor={background || "info"}
        // height="300px"
        width="100vw"
        position="absolute"
        top={0}
        left={0}
        // sx={darkMode ? { bgColor: ({ palette: { background } }: any) => background.default } : {}}
        sx={{
          height: {
            xs:'200px',
            md:'200px',
            lg:'250px',
            xl:'300px',
          },
        }}
        {...rest}
      />
      {children}
    </Box>
  );
}

export default DashboardLayout;

